export const downloadPackagesExcelModalName: string = 'downloadProductPackagesExcel';
